import React, { useRef, useEffect } from "react";
import { useIntersection } from "react-use";
import gsap from "gsap";
import "./AppFeatures.css";
import downloadNow from "../../assets/Images/play.png";
import { Link } from "wouter";
import { Subscribe } from "unstated";
import recspContainer from "../../Store/recspContainer";

const AppFeature = () => {
  const sectionRef = useRef(null);

  const intersection = useIntersection(sectionRef, {
    root: null,
    rootMargin: "0px",
    threshold: 0.3,
  });

  const fadeIn = () => {
    gsap.to(".fadeIn2", { opacity: 1, y: 0, duration: 1, stagger: 0.2 });
  };

  const fadeOut = () => {
    gsap.to(".fadeIn2", { opacity: 0, y: 40, duration: 1, stagger: 0.2 });
  };

  useEffect(() => {
    if (!intersection) return;
    intersection.intersectionRatio < 0.2 ? fadeOut() : fadeIn();
  }, [intersection]);

  return (
    <Subscribe to={[recspContainer]}>
      {(rec) => (
        <div className="AppFeatureBox" ref={sectionRef}>
          <h3 className="fadeIn2">App Features Now in Website!</h3>
          <p className="appPara fadeIn2">
            Built for RECians, by RECians—Team UDAAN brings all the essential
            features you rely on,<br /> now smarter and smoother on the website.
          </p>

          <div>
            <Link to={rec.state.isLoggedIn ? "/questions" : "/login"}>
              <div className="FeatureBox fadeIn2">
                <span><i className="material-icons">import_contacts</i></span>
                <p>Question Paper</p>
                <p id="sPara">Offline download through app available</p>
              </div>
            </Link>

            <Link to={rec.state.isLoggedIn ? "/result" : "/login"}>
              <div className="FeatureBox fadeIn2">
                <span><i className="material-icons">library_add_check</i></span>
                <p>Results</p>
                <p id="sPara">Semester Result PDF available, check now</p>
              </div>
            </Link>

            <Link to={rec.state.isLoggedIn ? "/notes" : "/login"}>
              <div className="FeatureBox fadeIn2">
                <span><i className="material-icons">sticky_note_2</i></span>
                <p>Notes</p>
                <p id="sPara">Updated notes and materials anytime</p>
              </div>
            </Link>

            <Link to={rec.state.isLoggedIn ? "/assignments" : "/login"}>
              <div className="FeatureBox fadeIn2">
                <span><i className="material-icons">assignment</i></span>
                <p>Assignments</p>
                <p id="sPara">Submission & updates</p>
              </div>
            </Link>

            <Link to={rec.state.isLoggedIn ? "/gallery" : "/login"}>
              <div className="FeatureBox fadeIn2">
                <span><i className="material-icons">photo_library</i></span>
                <p>Gallery</p>
                <p id="sPara">Memories of college events</p>
              </div>
            </Link>
          </div>

          <div className="PlayDiv fadeIn2">
            <p>Get App on Google Play Store</p>
          </div>
          <a target="_blank" rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.udaan.recstudentportalV2">
            <img className="Play" alt="playStore" src={downloadNow} />
          </a>
        </div>
      )}
    </Subscribe>
  );
};

export default AppFeature;
